import { Box, Button, DialogWrapper, MarkdownRenderer } from "@memorang/ui";
import { useState } from "react";
import { TouchableOpacity } from "react-native";
import { Dialog } from "react-native-paper";

type NotifyDialogProps = {
	title: string;
	body: string;
	cta: string;
	handleCtaPress: () => void;
};

type DialogProps = NotifyDialogProps & {
	visible: boolean;
	handleClose: () => void;
};

type Props = NotifyDialogProps & {
	children?: React.ReactNode;
};

const NotifyAppLaunchDialog = ({
	visible,
	handleClose,
	title,
	body,
	cta,
	handleCtaPress,
}: DialogProps) => {
	const handlePress = async () => {
		await handleCtaPress();
		handleClose();
	};

	return (
		<DialogWrapper visible={visible} handleClose={handleClose} maxWidth="xs">
			<Dialog.Icon icon="cellphone-arrow-down" />
			<Dialog.Title style={{ textAlign: "center" }}>{title}</Dialog.Title>
			<Dialog.Content>
				<MarkdownRenderer text={body} />
			</Dialog.Content>
			<Dialog.Actions>
				<Button mode="text" onPress={handlePress}>
					{cta}
				</Button>
			</Dialog.Actions>
		</DialogWrapper>
	);
};

const NotifyAppLaunchContainer = ({
	children,
	title,
	body,
	cta,
	handleCtaPress,
}: Props) => {
	const [visible, setVisible] = useState(false);

	const handleClose = () => setVisible(false);
	const handleOpen = () => setVisible(true);

	return (
		<TouchableOpacity onPress={handleOpen}>
			<NotifyAppLaunchDialog
				visible={visible}
				handleClose={handleClose}
				title={title}
				body={body}
				cta={cta}
				handleCtaPress={handleCtaPress}
			/>
			<Box style={{ pointerEvents: "none" }}>{children}</Box>
		</TouchableOpacity>
	);
};

export default NotifyAppLaunchContainer;
